let base = window.location.href
let http = base.split('//')
let url = 'https://www.smartprotese.app'
if(http[0] === 'http:') {
    url = 'http://smart.test'
}

export default url
